<label
  [ngClass]="
    ctrl?.invalid && (ctrl?.touched || ctrl?.dirty)
      ? 'text-red-600'
      : 'text-gray-900'
  "
  [for]="htmlFor"
  >{{ label }}<span *ngIf="isRequired()" class="ml-0.5">*</span></label
>
